import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslatorService } from '../../../services/translate.service';
import { UserSessionService } from '../../../services/user-session.service';

@Component({
  selector: 'app-edit-fields-modal',
  templateUrl: './edit-fields-modal.component.html',
  styleUrls: ['./edit-fields-modal.component.scss']
})
export class EditFieldsModal implements OnInit {

  confirmButtonLabel: any = 'LABEL.SAVE'
  cancelButtonLabel: any = 'LABEL.CANCEL'
  form: FormGroup
  fieldsToActivate: any = []
  localData: any
  options: any = {}

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: UntypedFormBuilder,
    private translate: TranslatorService,
    private userSessionService: UserSessionService,
  ) {
    let formStructure: any = {}

    if (data) {
      this.localData = data
      //console.log(data)

      if (data.fieldsToActivate) {
        this.fieldsToActivate = data.fieldsToActivate
        data.fieldsToActivate.forEach((field: any) => {
          formStructure[field] = [null, Validators.required]
        });
      }

      if (data.options) {
        this.options = data.options || {}

        if (this.options.marketingNotes) {
          let currentLang = this.getCurrentLanguage()
          let currentMarketingNotes = this.options.marketingNotes
          currentMarketingNotes.forEach((marketingNote: any) => marketingNote.name = marketingNote.translations[currentLang])
          this.options.marketingNotes = currentMarketingNotes
        }

      }

      this.form = this.fb.group(formStructure)
    }

  }

  getCurrentLanguage() {
    return this.userSessionService.getCurrentLanguage()?.toUpperCase() || 'IT';
  }

  checkFieldsToActivate(key: string) {
    return this.fieldsToActivate?.includes(key)
  }

  getLabel(type: any) {

    switch (type) {
      case 'titleLabel':
        return this.translate.instant('LABEL.modifica');
      case 'textLabel':
        return '';
      default:
        break;
    }
    return '';
  }

  ngOnInit(): void {
  }

  disabledConfirmButton() {
    let disabled = false
    if (!this.form.valid) disabled = true
    return disabled
  }

  getLabelSelect(key: string) {
    switch (key) {
      case 'contactChannel':
        return this.translate.instant('REQUEST.CHANNEL');
      case 'origin':
        return this.translate.instant('LABEL.ORIGIN');
      case 'marketingNote':
        return this.translate.instant('LABEL.MARKETINGNOTES');
    }
  }

}
